import type { FC } from 'react';
import { LoginForm } from './components/Form';
import { AuthLayout } from '../../components/AuthLayout';

export const LoginPage: FC = () => {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};
